import React, {useState} from 'react';
import CanvasJSReact from '../../../assets/libraries/chart/canvasjs.react';
import "./columnchart.scss"
import IconDropdownMenu from "../../dropdownmenu/icondropdownmenu/icondropdownmenu";
import RangePicker from "../../rangepicker/rangepicker";

interface IColumnChart {
    title?: string
}

const ColumnChart = ({title}: IColumnChart) => {
    const [boxTitle, setBoxTitle] = useState("");
    const [activeData, setActiveDate] = useState("Today");
    const [dataPoints, setDataPoints] = useState([
        {label: "سه شنبه ۲۴ آبان", y: 200, color: '#FEE9EC'}
    ])
    const CanvasJS = CanvasJSReact.CanvasJS;
    const CanvasJSChart = CanvasJSReact.CanvasJSChart;
    const options = {
        title: {
            text: ""
        },
        dataPointMinWidth: 30,
        dataPointWidth: 70,
        dataPointMaxWidth: 90,
        animationEnabled: true,
        animationDuration: 3000,
        theme: "light2",
        backgroundColor: "white",
        axisX: {
            title: "",
            labelFontFamily: 'yekanbakh, sans-serif',
            labelFontColor: "#6F708E",
            labelFontSize: 11,
            labelFontWeight: "400",
            labelWrap: true,
            tickLength: 0,
            lineColor: "transparent",
            crosshair: {
                enabled: true,
                snapToDataPoint: true,
                color: '#C7C7CB',
                lineDashType: 'solid',
                labelMaxWidth: 0,
                labelBackgroundColor: "transparent",
                labelFontColor: "transparent",
                labelFontSize: 0,
            }
        },
        axisY: {
            labelFontFamily: "yekanbakh, sans-serif",
            labelFontColor: "#6F708E",
            labelFontSize: 12,
            labelFontWeight: "400",
            gridColor: "#E4E4E5",
            tickLength: 0,
            includeZero: true,
            interval: 100,
        },
        data: [
            {
                type: "column",
                dataPoints: dataPoints
            }
        ]
    }
    return (
        <div className="Column-Chart">
            {
                title !== "" ?
                    <p className="Column-Chart-Title py-2">{title}</p>
                    :
                    null
            }
            <div className="Filter-Box d-flex justify-content-between w-100 align-items-center">
                <IconDropdownMenu boxTitle={boxTitle} icon={<></>} title={'نمایش بر اساس'} menuItems={
                    [
                        {
                            title: 'تاریخ', action: () => {
                                setBoxTitle('تاریخ');
                            }
                        },
                        {
                            title: 'زمان', action: () => {
                                setBoxTitle('زمان');
                            }
                        },
                    ]
                }/>
                <div className="d-flex gap-2">
                    <div onClick={() => {
                        setActiveDate("Today");
                        setDataPoints([
                            {label: "سه شنبه ۲۴ آبان", y: 200, color: '#FEE9EC'}
                        ])
                    }} className={activeData === "Today" ? "Filter-Button active" : "Filter-Button"}>
                        امروز
                    </div>
                    <div onClick={() => {
                        setActiveDate("Last7");
                        setDataPoints(
                            [
                                {label: "سه شنبه ۲۴ آبان", y: 200, color: '#FEE9EC'},
                                {label: "چهارشنبه ۲۵ آبان", y: 400, color: '#FEE9EC'},
                                {label: "پنج شنبه ۲۶ آبان", y: 100, color: '#FEE9EC'},
                                {label: "جمعه ۲۷ آبان", y: 250, color: '#FEE9EC'},
                                {label: "شنبه ۲۸ آبان", y: 300, color: '#FEE9EC'},
                                {label: "یکشنبه ۲۹ آبان", y: 170, color: '#FEE9EC'},
                                {label: "دوشنبه ۳۰ آبان", y: 340, color: '#FEE9EC'},
                            ]
                        )
                    }} className={activeData === "Last7" ? "Filter-Button active" : "Filter-Button"}>
                        ۷ روز گذشته
                    </div>
                    <div onClick={() => {
                        setActiveDate("Last30");
                    }} className={activeData === "Last30" ? "Filter-Button active" : "Filter-Button"}>
                        ۳۰ روز گذشته
                    </div>
                    {/*<div onClick={() => {*/}
                    {/*    setActiveDate("ChosenTime");*/}
                    {/*}} className={activeData === "ChosenTime" ? "Filter-Button active" : "Filter-Button"}>*/}
                    {/*    <CalendarIcon/>*/}
                    {/*    &nbsp;&nbsp;*/}
                    {/*    انتخاب بازه زمانی*/}
                    {/*</div>*/}
                    <RangePicker activeData={activeData} setActiveDate={setActiveDate}/>
                </div>
            </div>
            <CanvasJSChart options={options}
                /* onRef={ref => this.chart = ref} */
            />
        </div>
    );
}

export default ColumnChart